// extracted by mini-css-extract-plugin
module.exports = {"bottomMenu":"bottomMenu_bottomMenu__3M5Vj","menuButton":"bottomMenu_menuButton__2kOsm","active":"bottomMenu_active__29DAx"};